import * as actionTypes from '../actions/actionTypes';
import _ from 'lodash';

///////////////
// LIST VIEW //
///////////////
export const listViewStart = (dragIndex, dragID, blocks, blockIDs, sectionIndex, familyCount) => {
    
    return {
        type: actionTypes.LIST_VIEW_START,
        dragIndex: dragIndex,
        dragID: dragID,
        blocks: blocks,
        blockIDs: blockIDs,
        dndBlocks: blocks,
        dndBlockIDs: blockIDs,
        sectionIndex: sectionIndex,
        dndSectionIndex: sectionIndex,
        familyCount: familyCount
    }
}

export const listViewHover = (hoverIndex, dragIndex, blocks, blockIDs, parents) => {
    return {
        type: actionTypes.LIST_VIEW_HOVER,
        hoverIndex: hoverIndex,
        dragIndex: dragIndex,
        dndBlocks: blocks,
        dndBlockIDs: blockIDs,
        parents: parents
    }
}

export const listViewReset = () => {
    console.log('listViewReset')
    return {
        type: actionTypes.LIST_VIEW_RESET,
    }
}

